import React, { useState } from "react";
import ButtonBase from "@mui/material/ButtonBase";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import ib_logo from "img/ib-circle-logo.png";
import { useClientContext } from "contexts/client";
import { FeatureContext } from 'contexts/features';

export default function FeatureController() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const { state: clientState } = useClientContext();
  const featureList = clientState?.client?.featureList;
  const [, dispatch] = React.useContext(FeatureContext);
  
  return (
    <div>
      <ButtonBase
        focusRipple
        key={"Feature Select"}
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
        // onClick={() => setDialogOpen(true)}
        style={{
          width: 42,
          height: 40,
        }}
      >
        <span
          style={{
            background: `url(${ib_logo}) no-repeat`,
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            opacity: isShown ? 0.8 : 0.4,
            filter: isShown ? null : "grayscale(100%)",
            backgroundPosition: "center 3%",
          }}
        />
      </ButtonBase>

      <Dialog
        fullWidth={true}
        maxWidth={"lg"}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title">
          Feature Flag Overrides
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <form
            noValidate
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              width: "fit-content",
            }}
          >
            {featureList.map((feature, idx) => (
              <FormControlLabel
                key={idx}
                // className={classes.formControlLabel}
                control={
                  <Switch
                    checked={feature.active}
                    onChange={() =>
                      dispatch({
                        type: "IB/FEATURE_FLAG_UPDATE",
                        payload: {
                          index: idx,
                          active: !feature.active,
                        },
                      })
                    }
                    value="fullWidth"
                  />
                }
                label={feature.name}
              />
            ))}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
